import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/insurance-info.svg'
import _imports_2 from '@/app/ui/assets/svg/duplicate.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 mb-6 h-full overflow-y-auto"
}
const _hoisted_5 = { class: "w-2/3 pr-8 pl-4 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "ID Configurable", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Configurable Price ", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Deskripsi", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 w-3/4" }
const _hoisted_15 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold font-montserrat text-black-lp-300 text-20px pt-10 pb-8" }, " Daftar Asuransi ", -1)
const _hoisted_17 = { class: "font-semibold label-accordion flex flex-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 ml-2",
  alt: "info"
}, null, -1)
const _hoisted_19 = { class: "flex flex-row justify-center w-full text-gray-lp-300 py-8" }
const _hoisted_20 = { class: "flex flex-col w-1/3 pl-12" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Barang Min. ", -1)
const _hoisted_22 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold mt-4" }, " Harga Barang Maks. ", -1)
const _hoisted_25 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = { class: "flex flex-col w-1/3 pl-12" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Premi Min. ", -1)
const _hoisted_29 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold mt-4" }, " Harga Premi Maks. ", -1)
const _hoisted_32 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = { class: "flex flex-col w-1/3 pl-16" }
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Biaya Asuransi ", -1)
const _hoisted_36 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold mt-4" }, " Komisi POS ", -1)
const _hoisted_38 = { class: "text-12px xxl:text-14px mt-2" }
const _hoisted_39 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_40 = { class: "py-3 mt-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Vendor", -1)
const _hoisted_42 = { class: "my-1 text-black-lp-300" }
const _hoisted_43 = { class: "py-3" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Url", -1)
const _hoisted_45 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_46 = { class: "py-3" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Url", -1)
const _hoisted_48 = { class: "flex flex-row items-center relative" }
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "copy"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_51 = { class: "py-3" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Token", -1)
const _hoisted_53 = { class: "flex flex-row items-center relative" }
const _hoisted_54 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "copy"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_56 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l h-full border-gray-lp-400" }
const _hoisted_57 = { class: "py-3" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Configurable Price ", -1)
const _hoisted_59 = { class: "text-gray-lp-300 my-1" }
const _hoisted_60 = { class: "flex" }
const _hoisted_61 = { class: "py-3" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_63 = { class: "text-gray-lp-300 my-1" }
const _hoisted_64 = { class: "text-gray-lp-500" }
const _hoisted_65 = { class: "py-3" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_67 = { class: "text-gray-lp-300 my-1" }
const _hoisted_68 = { class: "text-gray-lp-500" }
const _hoisted_69 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            class: "w-5 mr-3 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.insurance.configPrice.configurablePriceName), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchDetailInsurance
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.insurance.configPrice.id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.insurance.configPrice.configurablePriceName), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.insurance.configPrice.configurablePriceDescription), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insurance.configurableInsurance.insuranceTypes, (e, i) => {
                    return (_openBlock(), _createBlock(_component_Accordion, {
                      key: i,
                      label: e.name,
                      class: "text-12px xxl:text-14px mb-5"
                    }, {
                      header: _withCtx(() => [
                        _createVNode("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString(e.name) + " ", 1),
                          _hoisted_18
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createVNode("p", _hoisted_22, [
                              _createTextVNode(" IDR " + _toDisplayString(e.priceGoodsMin) + " ", 1),
                              _hoisted_23,
                              _createTextVNode(" RM " + _toDisplayString(e.priceGoodsMinMY), 1)
                            ]),
                            _hoisted_24,
                            _createVNode("p", _hoisted_25, [
                              _createTextVNode(" IDR " + _toDisplayString(e.priceGoodsMax) + " ", 1),
                              _hoisted_26,
                              _createTextVNode(" RM " + _toDisplayString(e.priceGoodsMaxMY), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createVNode("p", _hoisted_29, [
                              _createTextVNode(" IDR " + _toDisplayString(e.pricePremiMin) + " ", 1),
                              _hoisted_30,
                              _createTextVNode(" RM " + _toDisplayString(e.pricePremiMinMY), 1)
                            ]),
                            _hoisted_31,
                            _createVNode("p", _hoisted_32, [
                              _createTextVNode(" IDR " + _toDisplayString(e.pricePremiMax) + " ", 1),
                              _hoisted_33,
                              _createTextVNode(" RM " + _toDisplayString(e.pricePremiMaxMY), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode("p", _hoisted_36, _toDisplayString(e.cost) + "%", 1),
                            _hoisted_37,
                            _createVNode("p", _hoisted_38, _toDisplayString(e.commisionPos) + "% ", 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode("div", _hoisted_42, _toDisplayString(_ctx.insurance.configurableInsurance.insuranceVendorName), 1)
                  ]),
                  _createVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("div", _hoisted_45, _toDisplayString(_ctx.insurance.configurableInsurance.insuranceIsApiUrl), 1)
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode("div", _hoisted_48, [
                      _createVNode("input", {
                        type: "hidden",
                        id: "link-api",
                        value: _ctx.insurance.configurableInsurance.insuranceApiUrl
                      }, null, 8, ["value"]),
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceApiUrl = $event)),
                        class: 
                  `py-2 xxl:py-3 px-3 font-montserrat text-12px xxl:text-14px rounded-r-none rounded border w-3/4 border-gray-lp-400 focus:outline-none text-black-lp-200 my-2 ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["disabled"]), [
                        [_vModelText, _ctx.insurance.configurableInsurance.insuranceApiUrl]
                      ]),
                      _createVNode("div", {
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
                  () =>
                    _ctx.getCopyText(_ctx.insurance.configurableInsurance.insuranceApiUrl)
                , ["stop","prevent"])),
                        class: "bg-gray-lp-700 flex flex-row rounded-r-md font-montserrat text-12px xxl:text-14px cursor-pointer text-red-lp-100 font-semibold text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-2 xxl:py-3 px-3"
                      }, [
                        _hoisted_49,
                        _hoisted_50
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.insurance.configurableInsurance.insuranceIsApiUrl === 'yes']
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode("div", _hoisted_53, [
                      _withDirectives(_createVNode("input", {
                        type: "hidden",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceApiToken = $event)),
                        id: "api-token"
                      }, null, 512), [
                        [_vModelText, _ctx.insurance.configurableInsurance.insuranceApiToken]
                      ]),
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceApiToken = $event)),
                        class: 
                  `py-2 xxl:py-3 px-3 w-3/4 font-montserrat text-12px xxl:text-14px rounded-r-none rounded border border-gray-lp-400 focus:outline-none text-black-lp-200 my-2 ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["disabled"]), [
                        [_vModelText, _ctx.insurance.configurableInsurance.insuranceApiToken]
                      ]),
                      _createVNode("div", {
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                  () =>
                    _ctx.getCopyText(
                      _ctx.insurance.configurableInsurance.insuranceApiToken
                    )
                , ["stop","prevent"])),
                        class: "bg-gray-lp-700 flex flex-row rounded-r-md text-red-lp-100 cursor-pointer font-semibold text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-2 xxl:py-3 text-12px xxl:text-14px px-3"
                      }, [
                        _hoisted_54,
                        _hoisted_55
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.insurance.configurableInsurance.insuranceIsApiUrl === 'yes']
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_56, [
                _createVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createVNode("div", _hoisted_59, [
                    _createVNode("div", _hoisted_60, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.statusInsurance ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${
                    _ctx.statusInsurance ? 'text-green-lp-200' : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", null, _toDisplayString(_ctx.statusInsurance ? "Active" : "Inactive"), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createVNode("div", _hoisted_63, _toDisplayString(_ctx.formatDate(_ctx.insurance.configPrice.configurablePriceCreatedAt)), 1),
                  _createVNode("div", _hoisted_64, _toDisplayString(_ctx.insurance.configPrice.configurablePriceCreatedBy), 1)
                ]),
                _createVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode("div", _hoisted_67, _toDisplayString(_ctx.insurance.configPrice.configurablePriceUpdatedAt ===
                "0001-01-01T00:00:00Z" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === "" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === null
                ? _ctx.formatDate(_ctx.insurance.configPrice.configurablePriceCreatedAt)
                : _ctx.formatDate(_ctx.insurance.configPrice.configurablePriceUpdatedAt)), 1),
                  _createVNode("div", _hoisted_68, _toDisplayString(_ctx.insurance.configPrice.configurablePriceUpdatedAt ===
                "0001-01-01T00:00:00Z" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === "" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === null
                ? _ctx.insurance.configPrice.configurablePriceCreatedBy
                : _ctx.insurance.configPrice.configurablePriceUpdatedBy), 1)
                ]),
                _createVNode("div", _hoisted_69, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: "Edit",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goEdit(_ctx.$route.params.id))),
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}